<template>
  <div>
    <el-form
      :inline="true"
      ref="formRef"
      :rules="formRules"
      :model="formInline"
      class="demo-form-inline">
      <el-form-item label="" prop="goodsNum">
        <el-input
          @keyup.native.enter="onSubmit"
          v-model="formInline.goodsNum"
          placeholder="请输入商品编号"
          clearable></el-input>
      </el-form-item>
      <el-form-item label="" prop="publisherName">
        <el-input
          @keyup.native.enter="onSubmit"
          v-model="formInline.publisherName"
          maxlength="30"
          placeholder="请输入发起企业名称"
          clearable></el-input>
      </el-form-item>
      <el-form-item label="" prop="bondTradeType">
        <el-select
          @keyup.native.enter="onSubmit"
          v-model="formInline.bondTradeType"
          maxlength="11"
          placeholder="请选择交易类型"
          clearable>
          <el-option
            v-for="item in bondTradeTypeList"
            :key="item.value"
            :label="item.status"
            :value="item.value"
            :disabled="item.disabled">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="tradeWay">
        <el-select
          @keyup.native.enter="onSubmit"
          v-model="formInline.tradeWay"
          maxlength="11"
          placeholder="请选择交易方式"
          clearable>
          <el-option
            v-for="item in tradeWayList"
            :key="item.value"
            :label="item.status"
            :value="item.value"
            :disabled="item.disabled">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="payWay">
        <el-select
          @keyup.native.enter="onSubmit"
          v-model="formInline.payWay"
          maxlength="11"
          placeholder="支付方式"
          clearable>
          <el-option
            v-for="item in payWayList"
            :key="item.value"
            :label="item.status"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <template>
        <el-form-item label="" prop="bondStatus" v-if="formInline.payWay === 0">
          <el-select
            @keyup.native.enter="onSubmit"
            v-model="formInline.bondStatus"
            maxlength="11"
            placeholder="请选择保证金状态"
            @focus="bondStatusfocus('bondStatus')"
            :disabled="bondStatusDiable"
            clearable>
            <el-option
              v-for="item in bondStatusList"
              :key="item.value"
              :label="item.status"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="offLineBondStatus" v-else>
          <el-select
            @keyup.native.enter="onSubmit"
            v-model="formInline.offLineBondStatus"
            maxlength="11"
            placeholder="请选择保证金状态"
            @focus="bondStatusfocus('offLineBondStatus')"
            :disabled="bondStatusDiable"
            clearable>
            <el-option
              v-for="item in offLineBondStatusList"
              :key="item.value"
              :label="item.status"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item label="" prop="binddingStatus">
        <el-select
          @keyup.native.enter="onSubmit"
          v-model="formInline.binddingStatus"
          maxlength="11"
          placeholder="竞价状态"
          clearable>
          <el-option
            v-for="item in binddingStatusList"
            :key="item.value"
            :label="item.status"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" prop="timeRange">
        <el-date-picker
          @change="pickerChange"
          v-model="timeRange"
          type="daterange"
          range-separator="-"
          value-format="yyyy-MM-dd"
          start-placeholder="支付开始日期"
          end-placeholder="支付结束日期"
          clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="clearForm">重置 </el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="exportSubmit" plain> 导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    const validateBondStatus = (rule, value, callback) => {
      if (this.bondStatusDiable) {
        return callback(new Error("请先选择支付方式"));
      } else {
        return callback();
      }
    };
    return {
      /** 保证金状态选择框禁用 */
      bondStatusDiable: false,
      /** 发布时间范围 */
      timeRange: [],
      /** 搜索表单数据 */
      formInline: {
        /** 商品编号 */
        goodsNum: "",
        /** 发起企业名称 */
        publisherName: "",
        /** 交易类型(1:煤炭交易，2:物流竞价） */
        bondTradeType: "",
        /** 交易方式(1:竞价采购，2:竞价销售  3：竞价物流) */
        tradeWay: "",
        /** 支付方式（0:线上支付,1:线下支付） */
        payWay: "",
        /** 线上保证金状态(1:支付成功、2:退还中、3:已退还、4:履约中、5:违约处置)*/
        bondStatus: "",
        /** 线下保证金状态（0:待审核,1:支付成功,2:审核拒绝,3:已退还,4:已扣除） */
        offLineBondStatus: "",
        /** 竞价状态(0:进行中，1:未中标，2:已中标 -1:未开始) */
        binddingStatus: "",
        /** 支付开始日期 */
        startTime: "",
        /** 支付结束日期 */
        endTime: "",
      },
      formRules: {
        bondStatus: [{ validator: validateBondStatus, trigger: "blur" }],
        offLineBondStatus: [{ validator: validateBondStatus, trigger: "blur" }],
      },
      /** 交易类型下拉选项 */
      bondTradeTypeList: [
        { status: "煤炭交易", value: 1 },
        { status: "物流交易", value: 2 },
      ],
      /** 交易方式下拉选项 */
      tradeWayList: [
        { status: "竞价采购", value: 1 },
        { status: "竞价销售", value: 2 },
        { status: "物流竞价", value: 3 },
      ],
      /** 支付方式下拉选项 */
      payWayList: [
        { status: "线上支付", value: 0 },
        { status: "线下支付", value: 1 },
      ],
      /** 线上保证金状态下拉选项 */
      bondStatusList: [
        { status: "支付成功", value: 1 },
        { status: "退还中", value: 2 },
        { status: "已退还", value: 3 },
        { status: "履约中", value: 4 },
        { status: "违约处置", value: 5 },
      ],
      /** 线下保证金状态下拉选项 */
      offLineBondStatusList: [
        { status: "待审核", value: 0 },
        { status: "支付成功", value: 1 },
        { status: "审核拒绝", value: 2 },
        { status: "已退还", value: 3 },
        { status: "已扣除", value: 4 },
      ],
      /** 竞价状态下拉选项 */
      binddingStatusList: [
        { status: "未开始", value: -1 },
        { status: "进行中", value: 0 },
        { status: "未中标", value: 1 },
        { status: "已中标", value: 2 },
      ],
    };
  },
  watch: {
    /** 支付方式改变 */
    "formInline.payWay": {
      handler(val) {
        if (val === 1 || val === 0) {
          this.formInline.bondStatus = "";
          this.formInline.offLineBondStatus = "";
          this.bondStatusDiable = false;
          this.$refs.formRef.clearValidate("bondStatus");
          this.$refs.formRef.clearValidate("offLineBondStatus");
        } else {
          this.formInline.bondStatus = "";
          this.formInline.offLineBondStatus = "";
        }
      },
    },
    /** 交易类型改变 */
    "formInline.bondTradeType": {
      handler(val) {
        /** 煤炭交易 */
        if (val == 1) {
          this.tradeWayList = [
            { status: "竞价采购", value: 1, disabled: false },
            { status: "竞价销售", value: 2, disabled: false },
            { status: "竞价物流", value: 3, disabled: true },
          ];
          if (this.formInline.tradeWay == 3) {
            this.formInline.tradeWay = "";
          }
          /** 物流竞价 */
        } else if (val == 2) {
          this.tradeWayList = [
            { status: "竞价采购", value: 1, disabled: true },
            { status: "竞价销售", value: 2, disabled: true },
            { status: "竞价物流", value: 3, disabled: false },
          ];
          if (this.formInline.tradeWay == 1 || this.formInline.tradeWay == 2) {
            this.formInline.tradeWay = "";
          }
        } else {
          this.tradeWayList = [
            { status: "竞价采购", value: 1, disabled: false },
            { status: "竞价销售", value: 2, disabled: false },
            { status: "竞价物流", value: 3, disabled: false },
          ];
        }
      },
    },
    /** 交易方式改变 */
    "formInline.tradeWay": {
      handler(val) {
        /** 竞价采购、竞价销售 */
        if (val == 1 || val == 2) {
          this.bondTradeTypeList = [
            { status: "煤炭交易", value: 1, disabled: false },
            { status: "物流交易", value: 2, disabled: true },
          ];
          /** 物流竞价 */
        } else if (val == 3) {
          this.bondTradeTypeList = [
            { status: "煤炭交易", value: 1, disabled: true },
            { status: "物流交易", value: 2, disabled: false },
          ];
        } else {
          this.bondTradeTypeList = [
            { status: "煤炭交易", value: 1, disabled: false },
            { status: "物流交易", value: 2, disabled: false },
          ];
        }
      },
    },
  },
  methods: {
    /** 保证金状态选择框获取焦点 */
    bondStatusfocus(type) {
      if (this.formInline.payWay === "") {
        this.formInline.bondStatus = "";
        this.formInline.offLineBondStatus = "";
        this.bondStatusDiable = true;
        this.$refs.formRef.validateField(type);
      }
    },
    /** 支付日期选择 */
    pickerChange(e) {
      if (e?.length) {
        this.formInline.startTime = e[0] + " 00:00:00";
        this.formInline.endTime = e[1] + " 23:59:59";
      } else {
        this.formInline.startTime = null;
        this.formInline.endTime = null;
      }
    },
    /** 导出 */
    exportSubmit() {
      this.$emit("exportSubmit");
    },
    /** 搜索 */
    onSubmit() {
      // if (this.formInline.payWay === "") {
      //   this.$refs.formRef.clearValidate();
      //   this.bondStatusDiable = false;
      // }
      // this.$refs.formRef.validate(valid => {
      //   if (valid) {
      this.search();
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    search() {
      this.$emit("search", this.formInline);
    },
    clearForm() {
      this.timeRange = [];
      this.formInline.startTime = "";
      this.formInline.endTime = "";
      this.$refs.formRef.resetFields();
      this.bondStatusDiable = false;
      this.search();
    },
  },
};
</script>

<style></style>
